var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-actions"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.activeSave},on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v("\n    保存\n  ")]),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("\n    キャンセル\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }